<div class="wrapper">
    <div *ngIf="!loading" class="body">
        <img class="logo" src="../../../assets/img/login.png" alt="img login">
        <h3>Registrar Usuario</h3>
        <div class="form-floating mb-3 mt-3">
            <input type="email" [(ngModel)]="username" class="form-control" placeholder="Ingrese usuario" pattern=".+@\.com" required>
            <label>Email usuario</label>
            <div id="emailHelp" class="form-text">Ingrese su dirección de correo</div>
            <div class="valid-feedback">
            Dato Ingresado
            </div>
            <div class="invalid-feedback">
            La descripción es un campo obligatorio.
            </div>
        </div>

        <div class="form-floating mb-3">
            <input type="password" [(ngModel)]="password" class="form-control" placeholder="Ingrese password">
            <label>Password</label>
        </div>
        <div class="form-floating mb-3">
            <input type="password" [(ngModel)]="confirmPassword" class="form-control" placeholder="Ingrese password de nuevo">
            <label>Repetir Password</label>
        </div>
        <div class="d-grid gap-2 mb-3">
            <button type="button" (click)="addUser()" class="btn btn-primary btn-lg">Aceptar</button>
        </div>
        <!--<a routerLink="/login">Volver</a>-->
    </div>
    <app-spinner *ngIf="loading"></app-spinner>
</div>